import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Seo } from "@/components/site/Section";
import { http, errorMessage, saveToken } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [f, setF] = useState({ password: "", password2: "" });
  const [state, setState] = useState({ loading: false, error: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return setState({ error: "Please choose a password of at least 8 characters." });
    if (f.password !== f.password2) return setState({ error: "Passwords don't match." });
    setState({ loading: true });
    try {
      const { data } = await http.post("/auth/reset-password", { token, password: f.password });
      saveToken(data.token);
      navigate("/account");
    } catch (err) {
      setState({ error: errorMessage(err) });
    }
  };
  return (
    <div className="lc-container grid min-h-[80vh] place-items-center pt-28 pb-20" data-testid="reset-page">
      <Seo title="Reset password" noindex />
      <form onSubmit={submit} noValidate className="w-full max-w-md space-y-4 rounded-3xl border border-[#262626] bg-[#101010] p-8" data-testid="reset-form">
        <h1 className="font-display text-3xl font-bold">Choose a new password</h1>
        {!token && <p className="text-sm text-[#ff8a3d]" data-testid="reset-missing">This link is incomplete. Please request a new reset link from the sign-in page.</p>}
        <div className="space-y-1.5">
          <Label htmlFor="reset-password">New password</Label>
          <Input id="reset-password" type="password" autoComplete="new-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="lc-input" data-testid="reset-password-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="reset-password2">Confirm new password</Label>
          <Input id="reset-password2" type="password" autoComplete="new-password" value={f.password2} onChange={(e) => setF({ ...f, password2: e.target.value })} className="lc-input" data-testid="reset-password2-input" />
        </div>
        {state.error && <p className="text-sm text-[#ff8a3d]" role="alert" data-testid="reset-error">{state.error}</p>}
        <button type="submit" disabled={state.loading || !token} className="lc-btn-primary w-full" data-testid="reset-submit">
          {state.loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save password and sign in"}
        </button>
        <Link to="/account" className="block text-center text-sm text-[#A1A1AA] hover:text-[#F7F5F0]" data-testid="reset-back">Back to sign in</Link>
      </form>
    </div>
  );
}
